import React, { useState, useContext } from "react";
import { i18n } from "../../translate/i18n";
import { 
    Avatar, 
    CardHeader, 
    Dialog,
    DialogContent,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AuthContext } from "../../context/Auth/AuthContext";
import getContactPictureUrl from "../../helpers/getContactPictureUrl";

const useStyles = makeStyles((theme) => ({
    // Estilos para o modal da imagem
    imageModal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    imageModalContent: {
        outline: "none",
        maxWidth: "90vw",
        maxHeight: "90vh",
    },
    expandedImage: {
        width: "100%",
        height: "auto",
        maxWidth: "500px",
        borderRadius: theme.spacing(1),
    },
    clickableAvatar: {
        cursor: "pointer",
        width: 44,
        height: 44,
        borderRadius: "50%",
        boxShadow: "0 0 0 2px rgba(37, 99, 235, 0.12)",
        "& .MuiAvatar-img": {
            objectFit: "cover",
        },
        "&:hover": {
            opacity: 0.8,
        },
        [theme.breakpoints.down("sm")]: {
            width: 38,
            height: 38,
        },
    },
    infoRoot: {
        minWidth: 0,
        flex: "1 1 auto",
        cursor: "pointer",
        padding: 0,
        "& .MuiCardHeader-content": {
            minWidth: 0,
        },
        "& .MuiCardHeader-title": {
            fontSize: 15,
            fontWeight: 700,
            color: theme.palette.text.primary,
            lineHeight: 1.2,
        },
        "& .MuiCardHeader-subheader": {
            fontSize: 12,
            color: theme.palette.text.secondary,
            lineHeight: 1.35,
        },
        [theme.breakpoints.down("sm")]: {
            "& .MuiCardHeader-title": {
                fontSize: 14,
            },
            "& .MuiCardHeader-subheader": {
                fontSize: 11,
            },
        },
    }
}));

const TicketInfo = ({ contact, ticket, onClick }) => {
    const classes = useStyles();
    const [amount, setAmount] = useState("");
    const { user } = useContext(AuthContext);
    const [imageModalOpen, setImageModalOpen] = useState(false); // Estado para o modal da imagem
    const contactPictureUrl = getContactPictureUrl(contact);

    // Função para abrir modal da imagem
    const handleImageClick = (e) => {
        e.stopPropagation(); // Prevenir que o clique no avatar execute outros handlers
        if (contactPictureUrl) {
            setImageModalOpen(true);
        }
    };

    // Função para fechar modal da imagem
    const handleImageModalClose = () => {
        setImageModalOpen(false);
    };

    const renderCardReader = () => {
        return (
            <CardHeader
                onClick={onClick}
                className={classes.infoRoot}
                titleTypographyProps={{ noWrap: true }}
                subheaderTypographyProps={{ noWrap: true }}
                avatar={
                    <Avatar 
                        src={contactPictureUrl} 
                        alt="contact_image" 
                        className={classes.clickableAvatar}
                        onClick={handleImageClick}
                    />
                }
                title={`${(contact?.name && contact.name.length > 12) ? 
                    `${contact.name.substring(0, 26)}...` : 
                    contact?.name || '(sem contato)'} · #${ticket?.id}`}
                subheader={[
                    ticket?.user && `${i18n.t("messagesList.header.assignedTo")} ${ticket?.user?.name}`,
                    contact?.contactWallets && contact.contactWallets.length > 0
                        ? `• ${i18n.t("wallets.wallet")}: ${contact.contactWallets[0].wallet?.name || 'N/A'}`
                        : null
                ].filter(Boolean).join(' ')}
            />
        );
    }

    const handleChange = (event) => {
        const value = event.target.value;
        setAmount(value);
    }

    return (
        <React.Fragment>
            {renderCardReader()}

            {/* Modal da Imagem */}
            <Dialog
                open={imageModalOpen}
                onClose={handleImageModalClose}
                className={classes.imageModal}
                maxWidth="md"
                fullWidth
            >
                <DialogContent className={classes.imageModalContent}>
                    <img 
                        src={contactPictureUrl} 
                        alt={contact?.name || "Foto do contato"}
                        className={classes.expandedImage}
                    />
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
};

export default TicketInfo;
